export default "__VITE_ASSET__DUUjT7dJ__"